/* Traduce al espanol los textos que algunas apps inyectan siempre en ingles.
   Solo actua si el idioma de la pagina es espanol. */
(function(){
  'use strict';
  var lang=(document.documentElement.getAttribute('lang')||'').toLowerCase();
  if(lang.indexOf('es')!==0) return;

  var MAP=[
    [/^(\s*)Earn\s+([\d.,]+)\s+points with this purchase(\s*)$/i,'$1Gana $2 puntos con esta compra$3'],
    [/^(\s*)Earn\s+([\d.,]+)\s+points(\s*)$/i,'$1Gana $2 puntos$3'],
    [/^(\s*)Earn points with our rewards? program(\s*)$/i,'$1Consigue puntos con nuestro programa de fidelidad$2'],
    [/^(\s*)You(?:'ll| will)? earn\s+([\d.,]+)\s+points(\s*)$/i,'$1Ganarás $2 puntos$3'],
    [/^(\s*)You have\s+([\d.,]+)\s+points(\s*)$/i,'$1Tienes $2 puntos$3'],
    [/^(\s*)Rewards? program(\s*)$/i,'$1Programa de fidelidad$2'],
    [/^(\s*)Your rewards(\s*)$/i,'$1Tus recompensas$2'],
    [/^(\s*)Redeem points(\s*)$/i,'$1Canjear puntos$2'],
    [/^(\s*)Join now(\s*)$/i,'$1Únete$2'],
    [/^(\s*)Points(\s*)$/,'$1Puntos$2']
  ];

  function hint(t){ return t.indexOf('oint')>-1 || t.indexOf('ewar')>-1 || t.indexOf('arn')>-1 || t.indexOf('Join')>-1; }

  function fix(node){
    if(!node) return;
    if(node.nodeType===3){
      var t=node.nodeValue;
      if(!t || !hint(t)) return;
      for(var i=0;i<MAP.length;i++){
        if(MAP[i][0].test(t)){ node.nodeValue=t.replace(MAP[i][0],MAP[i][1]); return; }
      }
      return;
    }
    if(node.nodeType!==1) return;
    var tag=node.tagName;
    if(tag==='SCRIPT'||tag==='STYLE'||tag==='NOSCRIPT') return;
    for(var c=node.firstChild;c;c=c.nextSibling) fix(c);
  }

  function runAll(){ try{ fix(document.body); }catch(e){} }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',runAll); else runAll();

  try{
    new MutationObserver(function(muts){
      for(var i=0;i<muts.length;i++){
        var m=muts[i];
        if(m.type==='characterData'){ fix(m.target); }
        else { for(var j=0;j<m.addedNodes.length;j++) fix(m.addedNodes[j]); }
      }
    }).observe(document.documentElement,{childList:true,subtree:true,characterData:true});
  }catch(e){}

  setTimeout(runAll,700);
  setTimeout(runAll,2000);
})();


/* ------------------------------------------------------------------
   Validación de correo en los formularios de la tienda.
   Evita que entren direcciones rotas (gmail.co, hotmial.com…) que
   rebotan siempre y ensucian la reputación de envío.
   - Bloquea solo lo que es claramente inválido.
   - Ante una errata probable, sugiere; nunca corrige sola.
   ------------------------------------------------------------------ */
(function(){
  'use strict';
  if(window.__tokeMailGuard) return; window.__tokeMailGuard = true;

  var DOMINIOS = [
    'gmail.com','hotmail.com','hotmail.es','outlook.com','outlook.es','yahoo.com',
    'yahoo.es','icloud.com','live.com','msn.com','me.com','protonmail.com',
    'proton.me','telefonica.net','terra.es','movistar.es','aol.com'
  ];

  // Distancia de edición, con corte temprano para no gastar ciclos.
  function distancia(a, b){
    if(a === b) return 0;
    if(Math.abs(a.length - b.length) > 2) return 99;
    var fila = [], i, j, prev, tmp;
    for(j = 0; j <= b.length; j++) fila[j] = j;
    for(i = 1; i <= a.length; i++){
      prev = fila[0]; fila[0] = i;
      for(j = 1; j <= b.length; j++){
        tmp = fila[j];
        fila[j] = Math.min(
          fila[j] + 1,
          fila[j-1] + 1,
          prev + (a.charAt(i-1) === b.charAt(j-1) ? 0 : 1)
        );
        prev = tmp;
      }
    }
    return fila[b.length];
  }

  function sintaxisOk(email){
    return /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/.test(email) &&
           /\.[a-zA-Z]{2,}$/.test(email);
  }

  function sugerencia(email){
    var at = email.lastIndexOf('@');
    if(at < 0) return null;
    var dominio = email.slice(at + 1).toLowerCase();
    if(!dominio) return null;
    for(var i = 0; i < DOMINIOS.length; i++){
      if(DOMINIOS[i] === dominio) return null;   // dominio conocido y correcto
    }
    var mejor = null, mejorD = 3;
    for(var k = 0; k < DOMINIOS.length; k++){
      var d = distancia(dominio, DOMINIOS[k]);
      if(d < mejorD){ mejorD = d; mejor = DOMINIOS[k]; }
    }
    if(!mejor) return null;
    return email.slice(0, at + 1) + mejor;
  }

  function quitarAviso(input){
    var n = input.parentNode && input.parentNode.querySelector('.toke-mailhint');
    if(n) n.parentNode.removeChild(n);
  }

  function mostrarAviso(input, propuesta){
    quitarAviso(input);
    if(!input.parentNode) return;
    var caja = document.createElement('div');
    caja.className = 'toke-mailhint';
    caja.setAttribute('role','status');
    caja.style.cssText = 'margin-top:6px;font-size:.8125rem;line-height:1.4;color:#8a6d3b;';
    var txt = document.createElement('span');
    txt.textContent = '¿Querías decir ';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = propuesta;
    btn.style.cssText = 'background:none;border:none;padding:0;font:inherit;color:inherit;text-decoration:underline;cursor:pointer;';
    btn.addEventListener('click', function(){
      input.value = propuesta;
      try{
        input.dispatchEvent(new Event('input', {bubbles:true}));
        input.dispatchEvent(new Event('change', {bubbles:true}));
      }catch(e){}
      quitarAviso(input);
      input.focus();
    });
    var fin = document.createElement('span');
    fin.textContent = '?';
    caja.appendChild(txt); caja.appendChild(btn); caja.appendChild(fin);
    input.parentNode.insertBefore(caja, input.nextSibling);
  }

  function esCampoEmail(el){
    if(!el || el.tagName !== 'INPUT') return false;
    var t = (el.getAttribute('type') || '').toLowerCase();
    if(t === 'email') return true;
    var n = ((el.name || '') + ' ' + (el.id || '')).toLowerCase();
    return t === 'text' && (n.indexOf('email') > -1 || n.indexOf('correo') > -1);
  }

  // Al salir del campo: sugerir, nunca corregir por su cuenta.
  document.addEventListener('blur', function(e){
    var el = e.target;
    if(!esCampoEmail(el)) return;
    var v = (el.value || '').trim();
    if(!v){ quitarAviso(el); return; }
    if(!sintaxisOk(v)){ quitarAviso(el); return; }
    var s = sugerencia(v);
    if(s) mostrarAviso(el, s); else quitarAviso(el);
  }, true);

  document.addEventListener('input', function(e){
    if(esCampoEmail(e.target)) quitarAviso(e.target);
  }, true);

  // Al enviar: bloquear solo lo que es imposible que exista.
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form || !form.querySelectorAll) return;
    var campos = form.querySelectorAll('input');
    for(var i = 0; i < campos.length; i++){
      var el = campos[i];
      if(!esCampoEmail(el)) continue;
      var v = (el.value || '').trim();
      if(!v) continue;
      if(!sintaxisOk(v)){
        e.preventDefault();
        e.stopPropagation();
        try{ el.setCustomValidity('Revisa el correo: falta el dominio o está incompleto.'); el.reportValidity(); }catch(err){}
        setTimeout(function(){ try{ el.setCustomValidity(''); }catch(err){} }, 50);
        el.focus();
        return;
      }
    }
  }, true);
})();
